import React, { useRef, useState, useEffect } from 'react';

// Component for auto-width select dropdown
export default function AutoWidthSelect({ value, onChange, disabled, disciplineColor, options, statusColor }) {
  const selectRef = useRef(null);
  const [width, setWidth] = useState(120);

  const getTextWidth = (text) => {
    if (!text || !selectRef.current) return 0;
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const computedStyle = window.getComputedStyle(selectRef.current);
    const font = `${computedStyle.fontWeight} ${computedStyle.fontSize} ${computedStyle.fontFamily}`;
    context.font = font;
    return context.measureText(text).width;
  };

  useEffect(() => {
    if (selectRef.current) {
      const selectedOption = options.find(dod => dod.id === value);
      const text = selectedOption ? selectedOption.name : "None";
      const textWidth = getTextWidth(text);
      // Add padding (6px left + 10px right = 16px) + some extra for dropdown arrow (~20px)
      const newWidth = Math.max(60, textWidth + 36);
      setWidth(newWidth);
    }
  }, [value, options]);

  return (
    <select
      ref={selectRef}
      value={value}
      onChange={onChange}
      disabled={disabled}
      style={{
        width: `${width - 10}px`,
        padding: '5px 8px',
        border: 'none',
        borderLeft: `2px solid ${statusColor || disciplineColor}`,
        borderRadius: "0px 3px 3px 0px",
        fontSize: 11,
        background: disabled ? '#f0f0f0' : '#fff',
        color: disabled ? '#999' : (statusColor || disciplineColor),
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontWeight: 500,
        margin: "2px 0px",
        marginRight: 2,
        outline: 'none',
        appearance: 'none',
        WebkitAppearance: 'none',
        MozAppearance: 'none'
      }}
    >
      <option value="">None</option>
      {options.map(dod => (
        <option key={dod.id} value={dod.id}>
          {dod.name}
        </option>
      ))}
    </select>
  );
}

